var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.999,
    height: 33.002,
    viewBox: "0 0 32.999 33.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_9",
    "data-name": "Exclusion 9",
    d: "M13831.5-5076a16.392,16.392,0,0,1-11.669-4.833A16.391,16.391,0,0,1,13815-5092.5a16.391,16.391,0,0,1,4.832-11.667A16.392,16.392,0,0,1,13831.5-5109a16.385,16.385,0,0,1,11.666,4.833A16.393,16.393,0,0,1,13848-5092.5a16.393,16.393,0,0,1-4.832,11.667A16.385,16.385,0,0,1,13831.5-5076Zm-.087-11.059a2.677,2.677,0,0,0-2.749,2.659,2.635,2.635,0,0,0,.812,1.931,2.794,2.794,0,0,0,1.938.755,2.709,2.709,0,0,0,2.787-2.687A2.7,2.7,0,0,0,13831.414-5087.058Zm.035-17.151a2.613,2.613,0,0,0-1.867.794,1.824,1.824,0,0,0-.534,1.35l.511,11.9a1.835,1.835,0,0,0,1.891,1.665,1.806,1.806,0,0,0,1.887-1.665l.511-11.9a1.752,1.752,0,0,0-.487-1.352A2.625,2.625,0,0,0,13831.449-5104.208Z",
    transform: "translate(-13815 5109.001)",
    fill: "#ffce00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.d17362804738aa539d466a841068da75.svg";
export { ForwardRef as ReactComponent };